<template>
  <div class="py-4 px-3 py-lg-3 px-lg-2">
    <div class="row">
      <div class="col-lg-6">
        <SelectHour />
      </div>
    </div>
  </div>
</template>

<script>
import SelectHour from '@/common/components/InitialManagementHour/SelectHour.vue';

export default {
  components: {
    SelectHour,
  }
}
</script>